import { Controller } from "@hotwired/stimulus"

const PROVIDER_PRESETS = {
  openrouter: {
    base_url: "https://openrouter.ai/api/v1/chat/completions",
    credentials_key: "open_router"
  },
  cloudflare: {
    base_url: "https://api.cloudflare.com/client/v4/accounts/{account_id}/ai/v1/chat/completions",
    credentials_key: "cloudflare_ai_gateway"
  }
}

export default class extends Controller {
  updatePrimaryPresets(event) {
    this.#applyPreset(event.target.value, "primary_provider")
  }

  updateSecondaryPresets(event) {
    this.#applyPreset(event.target.value, "secondary_provider")
  }


  #applyPreset(providerName, providerKey) {
    const preset = PROVIDER_PRESETS[providerName]
    if (!preset) return

    const baseUrlInput = this.element.querySelector(
      `[name="platform_setting[llm_provider_config][${providerKey}][base_url]"]`
    )
    const credentialsKeyInput = this.element.querySelector(
      `[name="platform_setting[llm_provider_config][${providerKey}][credentials_key]"]`
    )

    if (baseUrlInput) baseUrlInput.value = preset.base_url
    if (credentialsKeyInput) credentialsKeyInput.value = preset.credentials_key
  }
}
